import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import styles from './HorizontalLineSlatePlugin.scss'
import { TRIGGER_KEY, hasHorizontalLine, onClickButton } from './HorizontalLineSlatePluginContainer'

class HorizontalLineButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, onChange, style } = this.props
    const isActive = hasHorizontalLine(editorState)

    const customStyle = {}

    return (
      <Button
        id={'HorizontalLineButton' + this.uid}
        style={{...style, ...customStyle}}
        onClick={e => onChange(onClickButton(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.HorizontalLineButton}
      > ---
        {
          process.env.NODE_ENV !== 'test' &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'HorizontalLineButton' + this.uid} toggle={this.toggle}>
            Horizontal Line (CTL+{TRIGGER_KEY.toUpperCase()})
          </Tooltip>
        }
      </Button>
    )
  }
}

HorizontalLineButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object
}

export default HorizontalLineButton



// WEBPACK FOOTER //
// ./src/components/HorizontalLineSlatePlugin/HorizontalLineButton.js